// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Barve bilumina site:
highlight: f89624
nav: 292c2f

*/

a {
 text-decoration:none;
}
.myNavigation{
  background-color: #292c2f;
  height: 55px;
  padding:5px;
  text-align:center;

}

.padLeft{
  padding-right: 20px;
}

.colorItems {
  color: white;
}

.colorItems:hover{
  color: #f89624;
}

/* v primeru, da gledamo preko tablice pa do telefon */
@media (max-width: 900px) {
  .mobileHide {
    visibility: hidden;
    display: none;
  }
  .navLinkLogin {
    color: white;
  }
}
@media (min-width: 900px) {
  .desktopHide {
    visibility: hidden;
    display: none;
  }
  .navLinkLogin {
    color: white;
    padding-right: 40px;
  }
}
button {
  outline: none !important;
}


.navLinkLogin:hover {
  color: #f89624;
}

::ng-deep.mat-menu-panel {
  width: 150px !important;
}
.example-icon {
  padding: 0 14px;
}

.example-spacer {
  flex: 1 0 auto;
}

.mat-toolbar-multiple-rows {
  min-height: 55px;
}
.mat-toolbar {
  background-color: #292c2f ;
}

.mat-icon {
  font-size: 30px;
  outline: none;
  min-width: 30px;
  min-height: 30px;
}

.btn {
  min-width: 40px;
  padding: 0;
}

.toggleTabButtons {
  color:orange;
  border: solid 1px orange;
  /*background-color: #292c2f;*/
  margin-right: 20px;
}

mat-button-toggle:hover {
  background-color: #ffd8a7 !important;
  color:white;
}

.mat-button-toggle-checked {
    background-color: #ffd8a7 !important;
    color:white;
}
@media(max-width: 650px){

  .helpdeskTabButtonsHide {
    display: none;
  }
}

.hideDiv{
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/app/navigation/navigation.component.css"],"names":[],"mappings":"AAAA;;;;;CAKC;;AAED;CACC,oBAAoB;AACrB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,iBAAiB;;AAEnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA,sDAAsD;AACtD;EACE;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,YAAY;IACZ,mBAAmB;EACrB;AACF;AACA;EACE,wBAAwB;AAC1B;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;IACI,oCAAoC;IACpC,WAAW;AACf;AACA;;EAEE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;AACf","sourcesContent":["/*\nBarve bilumina site:\nhighlight: f89624\nnav: 292c2f\n\n*/\n\na {\n text-decoration:none;\n}\n.myNavigation{\n  background-color: #292c2f;\n  height: 55px;\n  padding:5px;\n  text-align:center;\n\n}\n\n.padLeft{\n  padding-right: 20px;\n}\n\n.colorItems {\n  color: white;\n}\n\n.colorItems:hover{\n  color: #f89624;\n}\n\n/* v primeru, da gledamo preko tablice pa do telefon */\n@media (max-width: 900px) {\n  .mobileHide {\n    visibility: hidden;\n    display: none;\n  }\n  .navLinkLogin {\n    color: white;\n  }\n}\n@media (min-width: 900px) {\n  .desktopHide {\n    visibility: hidden;\n    display: none;\n  }\n  .navLinkLogin {\n    color: white;\n    padding-right: 40px;\n  }\n}\nbutton {\n  outline: none !important;\n}\n\n\n.navLinkLogin:hover {\n  color: #f89624;\n}\n\n::ng-deep.mat-menu-panel {\n  width: 150px !important;\n}\n.example-icon {\n  padding: 0 14px;\n}\n\n.example-spacer {\n  flex: 1 0 auto;\n}\n\n.mat-toolbar-multiple-rows {\n  min-height: 55px;\n}\n.mat-toolbar {\n  background-color: #292c2f ;\n}\n\n.mat-icon {\n  font-size: 30px;\n  outline: none;\n  min-width: 30px;\n  min-height: 30px;\n}\n\n.btn {\n  min-width: 40px;\n  padding: 0;\n}\n\n.toggleTabButtons {\n  color:orange;\n  border: solid 1px orange;\n  /*background-color: #292c2f;*/\n  margin-right: 20px;\n}\n\nmat-button-toggle:hover {\n  background-color: #ffd8a7 !important;\n  color:white;\n}\n\n.mat-button-toggle-checked {\n    background-color: #ffd8a7 !important;\n    color:white;\n}\n@media(max-width: 650px){\n\n  .helpdeskTabButtonsHide {\n    display: none;\n  }\n}\n\n.hideDiv{\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
